import React from "react";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";

import { EffectCards } from "swiper";

import "./OnboardingStyle.css";
import OnboardingContent from "./OnboardingContent";

// import illustration assets
import logo_filled from "../../assets/logo_filled.svg";
import illu_remoteSearch from "../../assets/illustrations/onboarding/illustration_remotesearch.svg";
import illu_qrSearch from "../../assets/illustrations/onboarding/illustration_qr.svg";
import illu_alerts from "../../assets/illustrations/onboarding/illustration_alerts.svg";
import illu_freeRooms from "../../assets/illustrations/onboarding/illustration_rooms.svg";
import illu_overview from "../../assets/illustrations/onboarding/illustration_welcome.svg";

const OnboardingCards = ({ serverData }) => {
  const [onboardingSwiper, setOnboardingSwiper] = useState({});

  const calcTotalRooms = () => {
    if (serverData.allRoomIDs && serverData.allRoomIDs !== null)
      return serverData.allRoomIDs.length;
    else return "-";
  };

  const calcTotalBuildings = () => {
    if (serverData.allRoomBuildings && serverData.allRoomBuildings !== null)
      return serverData.allRoomBuildings.length;
    else return "-";
  };

  const handleNext = (swiper) => {
    swiper.slideNext();
  };

  const handlePrev = (swiper) => {
    swiper.slidePrev();
  };

  return (
    <div className="onboarding-cards-container">
      <Swiper
        effect={"cards"}
        grabCursor={true}
        modules={[EffectCards]}
        onInit={(swiper) => {
          setOnboardingSwiper(swiper);
        }}
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <OnboardingContent
            title={<>Willkommen bei loc.ur.de!</>}
            imgPath={logo_filled}
            onPrevClicked={undefined}
            onNextClicked={() => handleNext(onboardingSwiper)}
            description={
              <>
                Bei uns können Sie al&shy;le re&shy;le&shy;van&shy;ten
                In&shy;for&shy;ma&shy;tio&shy;nen über ei&shy;nen Raum
                er&shy;fra&shy;gen. Da&shy;zu zäh&shy;len ne&shy;ben{" "}
                <strong>
                  all&shy;ge&shy;mei&shy;nen
                  Raum&shy;in&shy;for&shy;ma&shy;tio&shy;nen
                </strong>{" "}
                auch{" "}
                <strong>Raum&shy;be&shy;le&shy;gungs&shy;plä&shy;ne</strong>,{" "}
                <strong>Raum&shy;aus&shy;stat&shy;tung</strong>,{" "}
                <strong>
                  in&shy;di&shy;vi&shy;du&shy;el&shy;le
                  Stö&shy;rungs&shy;mel&shy;dun&shy;gen
                </strong>
                , und vie&shy;les mehr!
              </>
            }
          />
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <OnboardingContent
            title={<>Allgemeine Informationen</>}
            imgPath={illu_overview}
            onPrevClicked={() => handlePrev(onboardingSwiper)}
            onNextClicked={() => handleNext(onboardingSwiper)}
            description={
              <>
                Derzeit sind <strong>{calcTotalRooms()}</strong> Räu&shy;me
                inner&shy;halb von <strong>{calcTotalBuildings()}</strong>{" "}
                Ge&shy;bäude&shy;kom&shy;plexen in die&shy;ser
                An&shy;wen&shy;dung hin&shy;ter&shy;legt.
              </>
            }
          />
          {/* Aber auch aktuell freie Räume lassen sich über diese Anwendung finden. Nutze hierfür die andere freie Schaltfläche am unteren Bildschirmrand. */}
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <OnboardingContent
            title={<>Manuelle Raumsuche</>}
            imgPath={illu_remoteSearch}
            onPrevClicked={() => handlePrev(onboardingSwiper)}
            onNextClicked={() => handleNext(onboardingSwiper)}
            description={
              <>
                Egal wo Sie sich be&shy;fin&shy;den &shy;&ndash;
                &shy;su&shy;chen Sie <strong>re&shy;mote</strong> nach
                ei&shy;nem Raum auf dem Cam&shy;pus und
                in&shy;for&shy;mie&shy;ren Sie sich über al&shy;les, dass es
                da&shy;rü&shy;ber zu be&shy;rich&shy;ten gibt!
              </>
            }
          />
          {/* Egal wo du dich befindest &ndash; suche <strong>remote</strong> nach einem Raum auf dem Campus und informiere dich über alles, das es darüber zu berichten gibt! */}
        </SwiperSlide>

        {/* Slide 4 */}
        <SwiperSlide>
          <OnboardingContent
            title={<>QR-Scan vor Ort</>}
            imgPath={illu_qrSearch}
            onPrevClicked={() => handlePrev(onboardingSwiper)}
            onNextClicked={() => handleNext(onboardingSwiper)}
            description={
              <>
                Falls Sie vor einem Raum stehen, der Ihr
                In&shy;te&shy;res&shy;se ge&shy;weckt hat, nut&shy;zen Sie
                ger&shy;ne den <strong>QR-&shy;Scan</strong> für die
                An&shy;zei&shy;ge!
              </>
            }
          />
          {/* Falls du vor dem Raum stehst, der dein Interesse geweckt hat, nutze gerne den <strong>QR-Scan</strong> für die Anzeige! */}
        </SwiperSlide>

        {/* Slide 5 */}
        <SwiperSlide>
          <OnboardingContent
            title={<>Erhalte allgemeine Störungsmeldungen</>}
            imgPath={illu_alerts}
            onPrevClicked={() => handlePrev(onboardingSwiper)}
            onNextClicked={() => handleNext(onboardingSwiper)}
            description={
              <>
                Von Zeit zu Zeit ex&shy;is&shy;tie&shy;ren{" "}
                <strong>
                  all&shy;ge&shy;mei&shy;ne
                  Stö&shy;rungs&shy;mel&shy;dun&shy;gen
                </strong>{" "}
                zu Sys&shy;te&shy;men, die eben&shy;falls über die&shy;se
                An&shy;wen&shy;dung ein&shy;seh&shy;bar sind. Nut&shy;zen Sie
                hier&shy;zu die Schalt&shy;flä&shy;chen am un&shy;te&shy;ren
                Bild&shy;schirm&shy;rand. Dort kön&shy;nen Sie auch sel&shy;bst
                Stö&shy;run&shy;gen mel&shy;den.
              </>
            }
          />
          {/* Von Zeit zu Zeit existieren allgemeine Störungsmeldungen zu Systemen, die ebenfalls über diese Anwendung einsehbar sind. Nutze hierzu eine der beiden Schaltflächen am unteren Bildschirmrand. */}
        </SwiperSlide>

        {/* Slide 6 */}
        <SwiperSlide>
          <OnboardingContent
            title={<>Finde schnell freie Räume</>}
            imgPath={illu_freeRooms}
            onPrevClicked={() => handlePrev(onboardingSwiper)}
            onNextClicked={undefined}
            description={
              <>
                <p>
                  <strong>
                    Diese Funk&shy;tion kann lei&shy;der noch nicht ge&shy;nutzt
                    wer&shy;den.
                  </strong>{" "}
                </p>
                <p>
                  Aber auch <strong>ak&shy;tu&shy;ell freie Räu&shy;me</strong>{" "}
                  las&shy;sen sich über die&shy;se An&shy;wen&shy;dung
                  fin&shy;den. Nut&shy;zen Sie hier&shy;für die an&shy;dere
                  freie Schalt&shy;flä&shy;che am un&shy;te&shy;ren
                  Bild&shy;schirm&shy;rand.
                </p>
              </>
            }
          />
          {/* Aber auch aktuell freie Räume lassen sich über diese Anwendung finden. Nutze hierfür die andere freie Schaltfläche am unteren Bildschirmrand. */}
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default OnboardingCards;
